const basicContract = {
  additionalHolidays: '',
  administrativeDays: '',
  bankAccount: '',
  bankAccountType: '',
  bankId: '',
  branchOffices: [],
  branchOfficeIds: [],
  checkAssistance: false,
  vacationCalculationArticle67: false,
  workScheduleArt27: false,
  dailyWorkingHours: '',
  telecommuting: false,
  contractType: '',
  costCenterId: '',
  disability: '',
  disabilityNationalIdentification: '',
  documentTemplateId: '',
  employee: {},
  endDate: '',
  friday: false,
  gratificationType: '',
  gratificationPeriod: '',
  gratificationCondition: '',
  jacketSize: '',
  jobManagementId: '',
  jobTitleId: '',
  markingType: '',
  monday: false,
  outSourced: false,
  outSourceAddress: '',
  outSourceAddressFlat: '',
  outSourceAddressNumber: '',
  outSourceAddressOffice: '',
  outSourceBusinessName: '',
  outSourceCommuneId: '',
  outSourceEstablishmentName: '',
  outSourceExceptionalSystem: false,
  outSourceExceptionalSystemNumber: '',
  outSourceNationalIdentification: '',
  outSourceRegionId: '',
  pantsSize: '',
  parentId: '',
  payFirstLicenseDays: false,
  paymentSchedule: '',
  paymentType: '',
  presenceCheckAssistance: false,
  progressiveFileInfo: {},
  progressiveVacationsCertificate: {},
  recognizedMonths: '',
  recognizedMonthsFrom: '',
  salary: '',
  saturday: false,
  shiftIds: [],
  shifts: [],
  shirtSize: '',
  shoesSize: '',
  startDate: '',
  sunday: false,
  syndicateId: '',
  tShirtSize: '',
  thursday: false,
  tuesday: false,
  wednesday: false,
  weeklyHours: '',
  workEndTime: '',
  workSchedule: '',
  workStartTime: '',
  contractBalancesAttributes: [],
  employeePrevisionAttributes: [],
  contractCostCentersAttributes: []
};

export default basicContract;
